import { Component, OnInit } from '@angular/core';
import { SupporterService } from 'src/app/services/supporter.service';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-supporter',
  templateUrl: './supporter.component.html',
  styleUrls: ['./supporter.component.scss']
})
export class SupporterComponent implements OnInit {
  public supporter:any={};
  public supporterLoaded:boolean=false;
  public supporterId;
  public supporterImage:string='';
  public newImageB64:string='';
  public newFileType:string='';
  public environment=environment;

  constructor(
    private _supporter: SupporterService,
    private _notify: MatSnackBar,
    private _route: ActivatedRoute
  ) {
    this.supporterId=this._route.snapshot.paramMap.get('supporterId');
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  public newImage(evt){
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      if (!file.type.includes('image')) {
        this.notify('Only images can be uploaded.', 'OK');
      }
      this.newFileType=file.type;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    } else {
      this.newImageB64='';
      this.newFileType='';
      this.supporterImage = this.supporter.image;
    }
  }

  private _handleReaderLoaded(readerEvt) {
   var binaryString = readerEvt.target.result;
    this.newImageB64= btoa(binaryString);
    this.supporterImage='data:' + this.newFileType + ';base64, ' + this.newImageB64;
  }

  public resetImage(){
    this.supporterImage=this.supporter.image;
  }

  public updateSupporter(){
    if (this.supporter.name == '') return this.notify('Supporter name can not be blank.', 'OK');
    this._supporter.updateSupporter(this.supporter, this.newImageB64, this.newFileType).subscribe(
      (res:any) => {
        // console.log(res);
        this.notify('Supporter updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this._supporter.getSupporter(this.supporterId).subscribe(
      data => {
        this.supporter=data;
        this.supporter.image=this.supporterImage=environment.apiEndpoint+'/storage/supporters/'+data.image;
        this.supporterLoaded=true;
      }
    );
  }

}
